<template>
  <div class="saas-page-partners">
    <div class="saas-page-head">
      <div
        style="top: 50px"
        class="saas-rounded-shape saas-rounded-shape__default-left-2"
      ></div>

      <div
        style="top: 194px"
        class="saas-rounded-shape saas-rounded-shape--white saas-rounded-shape__default-left-2"
      >
        <img
          class="saas-rounded-shape-icon saas-rounded-shape-icon--grayscale"
          src="@saas/assets/images/partners/clovyr-logo.svg"
        />

        <div class="saas-rounded-shape-verified">
          <img src="@saas/assets/images/verified-check-icon.svg" />
        </div>
      </div>
      <div
        style="top: 194px"
        class="saas-rounded-shape saas-rounded-shape__default-left-1"
      ></div>

      <div
        class="saas-rounded-shape saas-rounded-shape--white saas-rounded-shape__default-right-3"
      >
        <img
          class="saas-rounded-shape-icon"
          src="@saas/assets/images/partners/pingflow-logo.svg"
        />

        <div class="saas-rounded-shape-verified">
          <img src="@saas/assets/images/verified-check-icon.svg" />
        </div>
      </div>

      <div
        style="top: 194px; right: -40px; width: 300px"
        class="saas-rounded-shape saas-rounded-shape__default-right-1"
      ></div>

      <h1 class="saas-page-head__title" v-html="formattedTitle"></h1>

      <p class="saas-page-head__description">
        {{ page.intro_description }}
      </p>

      <div class="saas-page-head__menu">
        <Dropdown v-model="partnerIndex" class="saas-page-head__menu-dropdown">
          <DropdownItem
            v-for="(segment, index) in partnerTypes"
            :key="segment.id"
            :name="segment.label"
            :value="index"
          ></DropdownItem>
        </Dropdown>

        <SegmentControl
          class="saas-page-head__menu-segment-control"
          :active-index.sync="partnerIndex"
          :initial-active-index="0"
          :segments="partnerTypes"
          size="large"
          type="rounded"
        ></SegmentControl>
      </div>
    </div>

    <div class="saas-partner-cards__wrapper">
      <div class="saas-page-partners__body">
        <div class="saas-partner-cards">
          <PartnerCard
            v-for="partner in filteredPartners"
            :key="partner.id"
            :partner="partner.value"
          />
        </div>
        <div class="saas-cta-box page-community__cta-box-with-margin">
          <div>
            <span class="saas-cta-box__title">{{ page.apply_title }}</span>
            <p class="saas-cta-box__text">
              {{ page.apply_text }}
            </p>
          </div>
          <div class="saas-cta-box__buttons">
            <Button
              tag="nuxt-link"
              :to="{ name: 'partners-apply' }"
              size="large"
            >
              Partner with Baserow
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'
import cmsPage from '@saas/mixins/cmsPage'
import PartnerCard from '@saas/components/PartnerCard'

export default {
  components: {
    PartnerCard,
  },
  mixins: [cmsPage],
  layout: 'saas',
  data() {
    return {
      partnerIndex: 0,
      partnerTypes: [
        { id: 'all', label: 'All partners' },
        { id: 'hosting', label: 'Hosting' },
        { id: 'implementation', label: 'Implementation' },
        { id: 'solution', label: 'Solution' },
      ],
    }
  },
  computed: {
    formattedTitle() {
      const md = MarkdownIt({ html: false, breaks: false })
      return md.renderInline(this.page.intro_title)
    },
    filteredPartners() {
      return this.page.partners.filter((partner) => {
        const type = this.partnerTypes[this.partnerIndex].id
        return this.partnerIndex === 0 || partner.value.type === type
      })
    },
  },
}
</script>
